import { Allergen, DietType } from 'lib/home/generated/types/api';

export const mealPreferenceLabelMap = {
  [DietType.Vegan]: 'Vegan',
  [DietType.Vegetarian]: 'Vegetarian',
  [DietType.Pescatarian]: 'Pescatarian',
  [DietType.NoRedMeat]: 'No Red Meat',
  [DietType.Flexitarian]: 'I Like It All',
  [DietType.DairyFree]: 'Dairy Free',
  [DietType.LowCarb]: 'Low Carb',
  [DietType.GlutenFree]: 'Gluten Free',
  [DietType.NonSpicy]: 'Non-Spicy',
  [Allergen.Eggs]: 'Eggs',
  [Allergen.Fish]: 'Fish',
  [Allergen.Milk]: 'Milk',
  [Allergen.Peanuts]: 'Peanuts',
  [Allergen.Shellfish]: 'Shellfish',
  [Allergen.Soybean]: 'Soybean',
  [Allergen.TreeNuts]: 'Tree Nuts',
  [Allergen.Wheat]: 'Wheat'
};

export const mealPreferenceIconMap = {
  [Allergen.Milk]: 'dairy',
  [Allergen.Eggs]: 'egg',
  [Allergen.Peanuts]: 'peanuts',
  [Allergen.Shellfish]: 'shellfish',
  [Allergen.Soybean]: 'soybean',
  [Allergen.TreeNuts]: 'treeNuts',
  [Allergen.Fish]: 'pescatarian',
  [Allergen.Wheat]: 'wheat',
  [DietType.DairyFree]: 'dairyFree',
  [DietType.GlutenFree]: 'glutenFree',
  [DietType.LowCarb]: 'lowCarb',
  [DietType.NonSpicy]: 'nonSpicy',
  [DietType.NoRedMeat]: 'noRedMeat',
  [DietType.Pescatarian]: 'pescatarian',
  [DietType.Vegan]: 'vegan',
  [DietType.Vegetarian]: 'vegetarian',
  [DietType.Flexitarian]: 'heart'
};
